import { getOpParams } from '../getOpParams';

import { useFeatureFlag } from './useFeatureFlag';

export const useIsMapsEnabled = () => {
  const { orgId } = getOpParams();

  const { value: isMapsEnabled, isLoading: isLoadingFeatureFlag } =
    useFeatureFlag<boolean>('ENABLE_MAPS_FULL_RELEASE', orgId); // Full release except for a couple orgs in prod/eu that need some hand-holding for site merge.

  return {
    value: isMapsEnabled,
    isLoading: isLoadingFeatureFlag,
  };
};
